import React from "react";

export const LazyCreateDealPage = React.lazy(
  () => import("modules/investorRole/pages/DealsPage/CreateDealPage/index"),
);
